import type { Epic, Todo } from "../../domain/entities.ts";
import { hierarchyParentId } from "../tasks/task-hierarchy.ts";

/** A task family has one effective epic, independent of board placement. */
export function effectiveEpicId(task: Todo, tasks: readonly Todo[]): string | null {
  const parentId = hierarchyParentId(tasks, task);
  const parent = parentId ? tasks.find(item => item.id === parentId) : undefined;
  return (parent || task).epicId || null;
}

export function epicProgress(epicId: string, tasks: readonly Todo[]) {
  const members = tasks.filter(task => !task.deleted && !task.archivedAt && !hierarchyParentId(tasks, task) && effectiveEpicId(task, tasks) === epicId);
  return { completed: members.filter(task => task.completed).length, total: members.length };
}

export function epicLabel(task: Todo, tasks: readonly Todo[], epics: readonly Epic[]): string {
  const id = effectiveEpicId(task, tasks);
  return epics.find(epic => epic.id === id && epic.rootId === task.rootId && !epic.deleted)?.name || "No goal";
}

export function matchesEpic(task: Todo, tasks: readonly Todo[], filter: string): boolean {
  return !filter || (filter === "none" ? !effectiveEpicId(task, tasks) : effectiveEpicId(task, tasks) === filter);
}
